module.exports = __webpack_public_path__ + "img/square.669b6a72.svg";